import { render, staticRenderFns } from "./pcTabs.vue?vue&type=template&id=6da814b9&scoped=true"
import script from "./pcTabs.vue?vue&type=script&lang=js"
export * from "./pcTabs.vue?vue&type=script&lang=js"
import style0 from "./pcTabs.vue?vue&type=style&index=0&id=6da814b9&prod&scoped=true&lang=scss"
import style1 from "./pcTabs.vue?vue&type=style&index=1&id=6da814b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da814b9",
  null
  
)

export default component.exports